import { Container, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  completed?: boolean;
  participantLimitReached?: boolean;
}

const QuestionnaireError: React.FC<Props> = ({ completed, participantLimitReached }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Container maxWidth={'lg'}>
      <Stack gap={4}>
        <Typography className={classes.title}>{t('errorDialogTitle')}</Typography>
        <Stack gap={2}>
          <Paper className={classes.textContainer} elevation={2} square={true}>
            <Stack gap={2}>
              <Typography className={classes.text} align={'center'}>
                {participantLimitReached
                  ? t('participantLimitReachedError')
                  : completed
                  ? t('leadQuestionnaireErrorAlreadyCompleted')
                  : t('leadQuestionnaireErrorAlreadyGeneric')}
              </Typography>
            </Stack>
          </Paper>
        </Stack>
      </Stack>
    </Container>
  );
};

const useStyles = makeStyles()((theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(32),
    textAlign: 'center',
    fontWeight: 'bold',
  },
  textContainer: {
    padding: '24px 32px',
    background: 'rgba(0,0,0,0.03)',
  },
  text: {
    fontSize: theme.typography.pxToRem(18),
  },
}));

export default QuestionnaireError;
